import { ComponentProps } from "react";

export default function DealTrackerIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width={24}
      height={23}
      viewBox="0 0 24 23"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M8.06 1.798c-2.174.827-4.762 3.09-5.924 5.211-1.35 2.444-.863 10.242.562 8.877.3-.288.263-.827-.075-2.049-1.2-4.168.975-8.66 5.25-10.817 2.025-1.042 6.45-.934 8.625.216 1.463.754 1.575.898.863 1.006-.863.108-1.125.575-.563.934.188.108.975.108 1.725-.036 1.35-.215 1.388-.251 1.275-1.653-.112-1.437-1.05-2.372-1.05-1.042 0 .647-.112.647-1.95-.252C14.173.972 10.686.792 8.061 1.798m13.126 6.324c.562 2.408.412 5.966-.338 7.332-.937 1.724-2.775 3.521-4.537 4.42-2.213 1.15-6.525 1.078-8.813-.108-1.462-.755-1.575-.898-.825-1.006.863-.108.975-1.007.15-.935-.262.036-.975.072-1.612.072-1.088.072-1.125.108-1.013 1.582.113 1.509 1.05 2.443 1.05 1.042 0-.683.075-.683 1.913.251 7.087 3.486 15.787-1.725 15.675-9.38-.038-2.12-.713-4.276-1.463-4.492-.375-.143-.412.144-.187 1.222" />
      <path d="M8.81 8.625c-1.875 2.875-1.875 2.731-.488 4.96l1.275 2.048h4.838l1.2-1.977c.675-1.078 1.237-2.048 1.237-2.156s-.562-1.078-1.2-2.12l-1.237-1.94-2.4-.037c-2.363-.036-2.4 0-3.225 1.222m4.688 1.438c.412.395.75 1.042.75 1.437 0 .934-1.275 2.156-2.25 2.156s-2.25-1.222-2.25-2.156c0-.395.337-1.042.75-1.437.412-.396 1.087-.72 1.5-.72.412 0 1.087.324 1.5.72" />
    </svg>
  );
}
